import { IconButtonProps } from './icon-button.model';
import { IconButtonView } from './icon-button.view';

export const IconButtonController = (props: IconButtonProps) => {
  return <IconButtonView {...props} />;
};
